import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import avatar from "../assets/images/avatar_picture.jpg"

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/reyawon" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/godfrey-kawi/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Godfrey 'Freya' Kawi</h1>
          <p>Computer Science Student</p>
        </div>
      </div>
    </div>
  );
}

export default Main;